import {neverland as $, render, html, useState} from 'neverland';
import { signIn, checkMFAStatus, getCurrentUser } from '../lib/cognito';

function assert(condition, message) {
	if (!condition) {
		throw new Error(message || "Assertion failed");
	}
}

const LoginPage = $(function({auth, setAuth}) {
	
	async function login() {
		document.getElementById('error-generic').classList.add('hide');

		let email = document.getElementById('email').value,
			password = document.getElementById('password').value;

		try {
			await signIn(email, password);
			// Cache userEmail in localStorage
			localStorage.setItem('userEmail', email);
			
			// Check MFA status from Cognito
			const user = getCurrentUser();
			try {
				const mfaStatus = await checkMFAStatus(user);
				if (!mfaStatus.PreferredMfaSetting) {
					// User needs to set up MFA
					setAuth(prevAuth => ({
						...prevAuth,
						publicPage: 'MFASetup',
						cognitoUser: user,
						userEmail: email
					}));
					return;
				}
			} catch (mfaErr) {
				console.warn('Could not check MFA status:', mfaErr);
				// If we can't check MFA status, assume setup is needed
				setAuth(prevAuth => ({
					...prevAuth,
					publicPage: 'MFASetup',
					cognitoUser: user,
					userEmail: email
				}));
				return;
			}
			
			setAuth(prevAuth => ({ ...prevAuth, userEmail: email }));
		} catch(err) {
			console.warn(err);
			if (err.type === 'NEW_PASSWORD_REQUIRED') {
				setAuth(prevAuth => ({
					...prevAuth,
					publicPage: 'ConfirmPassword',
					cognitoUser: err.user
				}));
			} else if (err.type === 'MFA_SETUP') {
				// First time login - force MFA setup
				localStorage.setItem('userEmail', email);
				setAuth(prevAuth => ({
					...prevAuth,
					publicPage: 'MFASetup',
					cognitoUser: err.user,
					userEmail: email
				}));
			} else if (err.type === 'MFA_REQUIRED') {
				// Require MFA verification (Cognito handles device remembering)
				localStorage.setItem('userEmail', email);
				setAuth(prevAuth => ({
					...prevAuth,
					publicPage: 'MFAVerify',
					cognitoUser: err.user,
					userEmail: email
				}));
			} else {
				document.getElementById('error-generic').textContent = 'Login failed';
				document.getElementById('error-generic').classList.remove('hide');
			}
		}
	}

	function clickLogin(event) {
		// Number 13 is the "Enter" key on the keyboard
		if (event.keyCode === 13) {
			event.preventDefault();
			document.getElementById("login-button").click();
		}
	}

	function forgotPassword() {
		setAuth(prevAuth => {
			let auth = {...prevAuth};
			auth.publicPage = 'ForgotPassword';
			return auth;
		})
	}
	


	return html`
		<div class='login-fields'>

			<label>Email</label>
			<input id="email" type="text" autofocus />

			<label>Password</label>
			<input id="password" type="password" onkeyup="${clickLogin}" />
			
			<button class="forgot-password" onclick="${forgotPassword}">Forgot password</button>

			<button id="login-button" onclick="${login}">Log In</button>

			<div id="error-generic" class="login-error hide">Login failed</div>

		</div>
	`;

});

export default LoginPage;